import { Component, OnInit } from '@angular/core';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { GeoDatumDto } from '@cradua/data';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { Observable } from 'rxjs';

@Component({
  selector: 'cradua-geo-datum-container',
  templateUrl: './geo-datum-container.component.html',
  styleUrls: ['./geo-datum-container.component.scss']
})
export class GeoDatumContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  geodatums$: Observable<GeoDatumDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("GeoDatum");
    this.geodatums$ = this.gatwayFacade.loadGateway("GeoDatum");
    this.geodatums$.subscribe(data => {
      console.log("data: cont. yufufy",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteGeoDatum(deletedValue: any) {
    this.gatwayFacade.remove("GeoDatum", deletedValue);
    // this.store.dispatch(GeoDatumStoreActions.removeGeoDatum({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitGeoDatum(formValue: any) {
    console.log("form value: ", formValue);
    formValue.GeoDatums = formValue.GeoDatums.reverse();
    event.preventDefault();
    const pullData = formValue.GeoDatums;
    //const newPullData = formValue.GeoDatumes;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllGeoDatum = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllGeoDatum.push(pullData[i]);
    }
  }

// check if the addAllGeoDatum array is not empty, then dispatch the data to the store
   if(addAllGeoDatum.length !== 0) {
    this.gatwayFacade.add('GeoDatum', addAllGeoDatum);
    // this.store.dispatch(GeoDatumStoreActions.addGeoDatum({newGeoDatum: addAllGeoDatum}));

   }

// dispatch update data to the store
this.gatwayFacade.update('GeoDatum', allUpdates, ['id']);
    // this.store.dispatch(GeoDatumStoreActions.updateGeoDatum({updateGeoDatum: allUpdates}));
    this.notificationService.success('Saved Successfully');
  }
}
